export class AssociateCommand implements IAssociateCommand {
    healthRosterUsername?: string | undefined;
    healthRosterPassword?: string | undefined;
    customerCode? : string | undefined;

    constructor(data?: IAssociateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRosterUsername = _data["healthRosterUsername"];
            this.healthRosterPassword = _data["healthRosterPassword"];
            this.customerCode = _data["customerCode"];
        }
    }

    static fromJS(data: any): AssociateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssociateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRosterUsername"] =  this.healthRosterUsername;
        data["healthRosterPassword"] = this.healthRosterPassword;
        data["customerCode"]= this.customerCode;
        return data; 
    }
}

export interface IAssociateCommand {
    healthRosterUsername?: string | undefined;
    healthRosterPassword?: string | undefined;
    customerCode? : string | undefined;
}
